
var template = require('./meeting_status_legend.twig');

export class MeetingStatusLegend {
    constructor() {
        this.dom = $(twig({ data: template }).render({statusLegends: app.appData.programStatuses}));
    }
}